export default {
    PROFILES_LOADED: 'PROFILES_LOADED',
    SELECTED_PROFILE: 'SELECTED',
}


// WEBPACK FOOTER //
// ./App/components/modules/measurement-validator/store/action-types.js